import { render, staticRenderFns } from "./Programacao.vue?vue&type=template&id=599a209a&"
import script from "./Programacao.vue?vue&type=script&lang=js&"
export * from "./Programacao.vue?vue&type=script&lang=js&"
import style0 from "./Programacao.vue?vue&type=style&index=0&id=599a209a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports